import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13fabddc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "faq-redirect m-claim__metadata-button",
  target: "_blank",
  href: "https://forum.manifold.xyz/t/introducing-props-fund-an-idea-challenge-or-proposal-lets-chat-about-it/7676"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " FAQ ", -1))
const _hoisted_3 = [
  _hoisted_2
]


export default /*#__PURE__*/_defineComponent({
  __name: 'FAQRedirect',
  setup(__props) {

// No script logic needed

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", _hoisted_1, _hoisted_3))
}
}

})